import { Sidebar } from 'react-admin'
export default Sidebar